import { ChangeDetectionStrategy, Component, Input, } from "@angular/core";
import { PaymentType } from "../../models";
import { SOTService } from "../../services";

@Component({
  selector: "sot-stepper",
  templateUrl: "./stepper.component.html",
  styleUrls: ["./stepper.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {

  @Input() public activeStep: "order" | "card" | "pager" | "payment" | "done";

  public get getHasCardScanStep(): boolean {
    return this._sotService.payAtCard;
  }
  public get getHasPagerScanStep(): boolean {
    return this._sotService.GetSettings().use_pager;
  }
  public get getHasPaymentStep(): boolean {
    return !this._sotService.payAtCard;
  }
  public get getHasDoneStep(): boolean {
    return this._sotService.payAtCard || this._sotService.GetPayType() !== PaymentType.atPOS;
  }

  constructor(
    private _sotService: SOTService,
    ) {
  }

}
